import { PageScaffold } from "../../shared/ui/PageScaffold";

const teacherLinks = [
  { to: "/t/:tenantSlug/teacher", label: "講師ホーム" },
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" }
];

export function TeacherAbsenceRequestPage() {
  return (
    <PageScaffold
      title="Teacher Absence Request"
      description="欠勤申請画面のプレースホルダーです。"
      links={teacherLinks}
    >
      <p>ここに欠勤申請 UI を実装します。</p>
    </PageScaffold>
  );
}
